import { render, staticRenderFns } from "./float.vue?vue&type=template&id=518f4b73&scoped=true&"
import script from "./float.vue?vue&type=script&lang=js&"
export * from "./float.vue?vue&type=script&lang=js&"
import style0 from "./float.vue?vue&type=style&index=0&id=518f4b73&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f4b73",
  null
  
)

export default component.exports